module.exports = __webpack_public_path__ + "img/cash.cf8dbc7c.png";